/**
 * Account & Legal Entity read/write shapes — mirrors the backend contract
 * (backend/app/.../module/crm/api/dto/*.java) so the frontend never guesses
 * at field names. Keep these in lockstep with the Java records; a mismatch
 * here is the kind of bug that only shows up at runtime otherwise.
 */

export const ACCOUNT_TYPES = [
  'ULTIMATE_PARENT',
  'HOLDING',
  'INTERMEDIATE',
  'OPERATING',
  'DIVISION',
] as const

export type AccountType = (typeof ACCOUNT_TYPES)[number]

export const ACCOUNT_STATUSES = ['ACTIVE', 'PROSPECT', 'INACTIVE', 'ARCHIVED'] as const

export type AccountStatus = (typeof ACCOUNT_STATUSES)[number]

export interface AccountView {
  id: string
  name: string
  parentAccountId: string | null
  parentAccountName: string | null
  ultimateParentId: string | null
  type: AccountType
  country: string
  region: string
  industry: string
  status: AccountStatus
  legalEntityCount: number
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}

export interface CreateAccountRequest {
  name: string
  parentAccountId?: string | null
  type: AccountType
  country: string
  region: string
  industry: string
  status?: AccountStatus
}

export interface PatchAccountRequest {
  name?: string | null
  parentAccountId?: string | null
  type?: AccountType | null
  country?: string | null
  region?: string | null
  industry?: string | null
  status?: AccountStatus | null
}

export interface LegalEntityView {
  id: string
  accountId: string
  accountName: string | null
  name: string
  jurisdiction: string
  taxIdentifiers: Array<Record<string, string>>
  entityGroupId: string | null
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}
